import type { Bet } from '../../../../../schema/coupon/entry.js';
import type { DrawNumber } from '../../../../../schema/draw/entry.js';
import type { Product } from '../../../../../schema/product/entry.js';
import { encodeSigns } from './utils/encodeSigns.js';

type UseShareableCouponUrlFromOutcomesProps = {
  product?: Product;
  drawNumber?: DrawNumber;
  outcomes: Bet;
  basePath: string;
};

/**
 * Hook to create a shareable coupon url from outcomes.
 *
 * @param root0 props
 * @param root0.product product for the coupon
 * @param root0.drawNumber draw number for the coupon
 * @param root0.outcomes outcomes of wager
 * @param root0.basePath base path for mfe
 * @returns shareable coupon url string
 */
export function useShareableCouponUrlFromOutcomes({
  product,
  drawNumber,
  outcomes,
  basePath,
}: UseShareableCouponUrlFromOutcomesProps): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const pathNames = [basePath];
  const shareableWagerUrl = new URL(`${window.location.protocol}//${window.location.hostname}`);
  shareableWagerUrl.pathname = pathNames.join('/');

  const qs = new URLSearchParams();
  if (product) {
    qs.set('product', product);
  }

  if (drawNumber) {
    qs.set('draw', drawNumber.toString());
  }
  const outcomesString = encodeSigns(outcomes);
  if (outcomesString) {
    qs.set('outcomes', outcomesString);
  }

  return `${shareableWagerUrl}?${qs.toString()}`;
}
